module.exports = __webpack_public_path__ + "catalog/items/firesafety/First-Aid-Red/First-Aid-Red.svg";